<script setup lang="ts">
import type { ReportDto } from '@/types'

const form = defineModel<ReportDto>({ required: true })

withDefaults(
  defineProps<{
    phoneRequired?: boolean
    showPriority?: boolean
    serviceLabel?: string
    servicePlaceholder?: string
  }>(),
  {
    phoneRequired: false,
    showPriority: true,
    serviceLabel: 'Betroffener Service / Bereich',
    servicePlaceholder: 'Service auswählen'
  }
)

const services = ['ConnectINVOICE', 'ConnectWORKFLOW', 'microtech-Daten', 'Suche', 'Anderes']
const priorities = [
  { value: 'high', label: 'Hoch' },
  { value: 'normal', label: 'Normal' },
  { value: 'low', label: 'Niedrig' }
]
</script>

<template>
  <div class="grid gap-6 md:grid-cols-2">
    <UFormField
      label="Ansprechpartner"
      name="contactPerson"
      required
      help="Aus Ihrem Benutzerkonto übernommen"
      class="w-full"
    >
      <UInput
        v-model="form.contactPerson"
        disabled
        placeholder="Vollständiger Name"
        class="w-full"
      />
    </UFormField>

    <UFormField
      label="E-Mail-Adresse"
      name="email"
      required
      help="Aus Ihrem Benutzerkonto übernommen"
      class="w-full"
    >
      <UInput
        v-model="form.email"
        type="email"
        disabled
        placeholder="ihre.mail@firma.de"
        class="w-full"
      />
    </UFormField>

    <UFormField
      :label="phoneRequired ? 'Telefonnummer für Rückruf' : 'Telefonnummer (optional)'"
      name="phoneNumber"
      :required="phoneRequired"
      class="w-full"
    >
      <UInput
        v-model="form.phoneNumber"
        placeholder="+49 123 456789"
        class="w-full"
      />
    </UFormField>

    <UFormField
      :label="serviceLabel"
      name="service"
      required
      class="w-full"
    >
      <USelect
        v-model="form.service"
        :items="services"
        :placeholder="servicePlaceholder"
        class="w-full"
      />
    </UFormField>

    <UFormField
      v-if="showPriority"
      label="Priorität"
      name="priority"
      required
      class="w-full"
    >
      <USelect
        v-model="form.priority"
        :items="priorities"
        placeholder="Priorität auswählen"
        class="w-full"
      />
    </UFormField>

    <div v-else class="flex flex-col justify-center">
      <span class="text-sm font-medium text-gray-700 dark:text-gray-300">Priorität</span>
      <p class="text-sm text-gray-500 mt-1">Priorität: Kritisch (Notfall)</p>
    </div>
  </div>
</template>
